import React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import EventsList from "../components/events/event-list";

class Programok extends React.Component {
  render() {
    return (
      <Layout>
        <Seo title="Programok" />
        <div id="app">
          <div className="container content-wrap">
            <div className="row my-3">
              <div className="col">
                <h1>Programok</h1>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <h2>Aktuális programjaink</h2>
              </div>
            </div>
            <EventsList />
          </div>
        </div>
      </Layout>
    );
  }
}

export default Programok;
